import React from 'react'
import { Button, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'
import { GoogleIcon, SlackIcon, TeamsIcon } from '../../../../components/icons'
import { PLATFORM_BRAND_NAME } from '../platform-brand'
import { DetectedPlatform } from '../types'

const { Paragraph, Text, Link } = Typography

const PLATFORM_ICON: Record<DetectedPlatform, React.ReactElement> = {
  slack: <SlackIcon />,
  microsoft: <TeamsIcon />,
  google: <GoogleIcon />,
}

export interface IChoosePlatformStepProps {
  email: string
  platforms: DetectedPlatform[]
  /** Only an email account has a password to sign in with. */
  hasEmailAccount: boolean
  isBusy: boolean
  onPlatformSignin: (platform: DetectedPlatform) => void
  onSigninWithEmail: () => void
  onChangeEmail: () => void
}

const ChoosePlatformStep = ({ email, platforms, hasEmailAccount, isBusy, onPlatformSignin, onSigninWithEmail, onChangeEmail }: IChoosePlatformStepProps): React.ReactElement => {
  const { formatMessage } = useIntl()

  return (
    <>
      <div className="signin-account-row">
        <Text strong data-qa="signin-resolved-email">
          {email}
        </Text>
        <Link onClick={onChangeEmail} data-qa="signin-change-email">
          <IntlMessages id="app.change" />
        </Link>
      </div>
      <Paragraph type="secondary" data-qa="signin-choose-platform-hint">
        <IntlMessages id="signin.choosePlatform.description" />
      </Paragraph>
      {platforms.map((platform) => (
        <Button key={platform} size="large" icon={PLATFORM_ICON[platform]} onClick={() => onPlatformSignin(platform)} disabled={isBusy} data-qa={`${platform}-connect`} block>
          {formatMessage({ id: 'signin.signInWithPlatform' }, { platform: PLATFORM_BRAND_NAME[platform] })}
        </Button>
      ))}
      {hasEmailAccount && (
        <Button size="large" onClick={onSigninWithEmail} disabled={isBusy} data-qa="email-connect" block>
          <IntlMessages id="connect.signInWithEmail" />
        </Button>
      )}
    </>
  )
}

export default ChoosePlatformStep
